import React from 'react';
import { FaHome, FaAngleRight } from 'react-icons/fa';
import './Breadcrumbs.css';

const Breadcrumbs = () => {
  return (
    <nav className="breadcrumbs-nav" aria-label="Breadcrumb" data-aos="fade-right">
      <div className="container">
        <ul className="breadcrumb-list">
          <li className="breadcrumb-item">
            <a href="/" className="breadcrumb-link"><FaHome /> Home</a>
          </li>
          <li className="breadcrumb-separator"><FaAngleRight /></li>
          <li className="breadcrumb-item">
            <span className="breadcrumb-current">Services</span>
          </li>
          <li className="breadcrumb-separator"><FaAngleRight /></li>
          <li className="breadcrumb-item">
            <span className="breadcrumb-current">Environmental Solutions Madurai</span>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Breadcrumbs;
